import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Router } from '@angular/router';
import p from '../products';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss']
})
export class ProductoComponent implements OnInit {

  @ViewChild('imgTag') imgTag: ElementRef;
  @ViewChild('nameTag') nameTag: ElementRef;
  @ViewChild('specTag') specTag: ElementRef;
  @ViewChild('featuresTag') featuresTag: ElementRef;
  @ViewChild('descriptionTag') descriptionTag: ElementRef;

  public listOfProducts = [];
  public products = p;
  public showSpec = false;

  name;
  features;
  spec;
  img;
  description;

  currentRoute;
  router;

  constructor(router: Router, ) {
    this.router = router;
    this.currentRoute = this.router.url;
  }



  ngOnInit() {
    // Eliminar en inicio de la URL
    for (let i = 0; i < 17; i++) {
       this.currentRoute = this.currentRoute.substr(1);
    }

    // Search Item

    for (const key in this.products) {
      if (this.products[key].uid === this.currentRoute) {
        this.nameTag.nativeElement.innerHTML = this.products[key].id;
        this.featuresTag.nativeElement.innerHTML = this.products[key].features;
        this.spec = this.products[key].spec;
        this.img = this.products[key].img;
        this.descriptionTag.nativeElement.innerHTML = this.products[key].description;
      }
    }
  }


  public showTheSpec() {
    this.showSpec = true;
    this.specTag.nativeElement.innerHTML = this.spec;
  }

}
